import $ from 'jquery';

const handleHamburgerClick = () => {
  console.log($('centered-menu'));
  $('#navbar-hamburger').toggleClass('open');
  $('.centered-menu').toggleClass('open');
};

export default () => {
  $('#navbar-hamburger').click(handleHamburgerClick);
};



// WEBPACK FOOTER //
// ./src/plugins/hamburger.js